import { render, staticRenderFns } from "./categoryMaintenance.vue?vue&type=template&id=033a057b&scoped=true&"
import script from "./categoryMaintenance.vue?vue&type=script&lang=js&"
export * from "./categoryMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033a057b",
  null
  
)

export default component.exports